import React from 'react';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Box, Flex } from '../../Layout';

const MainNavItem = styled(Box)`
`;

const activeClassName = 'nav-item-active';

const MainNavLink = styled(NavLink).attrs({
  activeClassName,
})`

  margin-right: ${themeGet('space.2')};
  text-decoration: none;
  color: ${themeGet('colors.ui.text')};
  border-bottom: 4px solid transparent;
  padding: ${themeGet('space.4')} 0;
  margin-right: ${themeGet('space.10')};
  font-size: ${themeGet('fontSizes.xl')};

  &:hover {
    border-bottom: 4px solid ${themeGet('colors.brand.secondary')};
  }

   &.${activeClassName} {
     border-bottom: 4px solid ${themeGet('colors.brand.primary')};
   }

   @media (max-width: ${themeGet('breakpoints.0')}) {
     color: white;
     padding: 0;
     &:hover {
       border-bottom: none;
       text-decoration: underline;
     }
   }

   @media (max-width: ${themeGet('breakpoints.1')}) {
     font-size: ${themeGet('fontSizes.lg')};
     margin-right: ${themeGet('space.6')};
   }
`;

const NavItems = () => (
  <Flex flexDirection={['column', 'row']} ml={['0', '12px']}>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/' exact>Home</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/about'>About</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/play'>Play</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/national-teams'>National Teams</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/news'>News</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/resources'>Resources</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/support'>Support</MainNavLink>
    </MainNavItem>
    <MainNavItem>
      <MainNavLink activeClassName={activeClassName} to='/contact'>Contact</MainNavLink>
    </MainNavItem>
  </Flex>
);

export default NavItems;



// WEBPACK FOOTER //
// ./src/MainNav/NavItems/NavItems.js